export const UPLOAD_MODE_CREATE = 'create';
export const UPLOAD_MODE_EDIT = 'edit';
export const UPLOAD_MODE_COPY = 'copy';
